import { ReactNode } from "react";

interface PageHeaderProps {
  crumb: string;
  title: string;
  sub?: string;
  actions?: ReactNode;
}

// Breadcrumb + title + subtitle on the left, action buttons on the right
const PageHeader = ({ crumb, title, sub, actions }: PageHeaderProps) => (
  <div className="cx-hdr">
    <div>
      <ul className="cx-crumb"><li>Master Admin</li><li>{crumb}</li></ul>
      <h1 className="cx-title">{title}</h1>
      {sub && <p className="cx-sub">{sub}</p>}
    </div>
    {actions && <div className="cx-actions">{actions}</div>}
  </div>
);

export default PageHeader;
